const PROFILE_REDIRECTS = {
  pQ4g: '/profile/atl-graphix-signage-digital-printing/beerwah-qld/Ta8i',
  ihqp: '/profile/albury-wodonga-cleaning-service/wodonga-vic/bACE',
  W8Ch: '/404',
  '3Vun': '/404',
  iKVS: '/404',
  RVeP: 'http://www.irelands.com.au/',
  XQB0: 'http://www.irelands.com.au/',
  z6mA: 'http://www.irelands.com.au/',
  OP5W: 'http://www.irelands.com.au/',
  IZuC: 'http://www.irelands.com.au/',
  '6reG': 'http://www.irelands.com.au/',
  Pv4v: 'http://www.irelands.com.au/',
  Tm3S: 'http://www.irelands.com.au/',
  i3VW: 'http://www.irelands.com.au/',
  ccuf: 'http://www.irelands.com.au/',
  j7r2: 'http://www.irelands.com.au/',
  W99H: '/profile/shellharbour-city-skip-bins/warilla-nsw/hCpI',
};

export default PROFILE_REDIRECTS;
